import React from 'react';
import { GiveawayInfoPage } from '../../partials/giveaway-info-page';
export default class SuccessPage extends React.Component {
  render() {
    return /*#__PURE__*/React.createElement(GiveawayInfoPage, {
      title: "Amazing, you're all finished!",
      subtitle: 'There is nothing else to do here so you can go ahead and close this tab!'
    });
  }
}